<script setup>
import { storeToRefs } from "pinia";

const globalStore = useGlobalStore();
const { footerLinksCol1, footerLinksCol2, footerLinksCol3, wysiwyg, navigationItems, snow } =
  storeToRefs(globalStore);
const { $getFooter } = useNuxtApp();
const { $getNavigation } = useNuxtApp();
const { $getGlobal } = useNuxtApp();
const constants = useConstants();
const route = useRoute();

const responseNavigation = await $getNavigation();
const responseFooter = await $getFooter();
const responseGlobal = await $getGlobal();
globalStore.footer = responseFooter;
globalStore.navigation = responseNavigation;
globalStore.global = responseGlobal;

const isMounted = ref(false);

onMounted(() => {
  isMounted.value = true;
});
</script>

<template>
  <div
    id="l-wrapper"
    class="bg-black min-h-screen flex flex-col pt-[80px] lg:pt-[100px]"
  >
    <Header :navigationItems="navigationItems" />
    <main id="l-main" class="relative flex-grow z-0">
      <slot />
    </main>
    <Footer :linksCol1="footerLinksCol1" :linksCol2="footerLinksCol2" :linksCol3="footerLinksCol3" :text="wysiwyg" />
    <!-- <Snow v-if="isMounted && snow" /> -->
  </div>
</template>

<style></style>
